module.exports = __webpack_public_path__ + "static/img/four.68b31ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solutions/smartsite/four.png
// module id = 5vaa
// module chunks = 12